import { useQuery } from '@tanstack/react-query';
import { AdminShell } from '@/components/layout/AdminShell';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { api } from '@/lib/api-client';
import { formatRelativeDate } from '@/lib/utils';

interface AuditEntry {
  id: string;
  actorId: string;
  action: string;
  details: Record<string, unknown>;
  createdAt: string;
}

export function AdminAuditLog() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'audit-log'],
    queryFn: () => api.get<{ items: AuditEntry[] }>('/admin/audit-log?limit=500'),
  });

  return (
    <AdminShell>
      <div className="max-w-5xl">
        <h1 className="font-serif text-display-lg">Audit log</h1>
        <p className="text-muted-foreground mt-1">Histórico imutável de ações administrativas.</p>

        <div className="mt-6 space-y-2">
          {isLoading && <p className="text-muted-foreground">Carregando…</p>}
          {data && data.items.length === 0 && (
            <Card>
              <CardContent className="pt-6 text-muted-foreground text-sm">
                Nenhuma ação administrativa registrada ainda.
              </CardContent>
            </Card>
          )}
          {data?.items.map((a) => (
            <Card key={a.id}>
              <CardContent className="pt-4 pb-4 flex items-start gap-3">
                <Badge variant="muted" className="font-mono text-[10px] flex-none mt-0.5">{a.action}</Badge>
                <div className="flex-1 min-w-0">
                  <pre className="text-xs text-muted-foreground whitespace-pre-wrap break-all font-mono">
                    {JSON.stringify(a.details, null, 0)}
                  </pre>
                  <p className="mt-1 text-xs text-muted-foreground">
                    Por <span className="font-mono">{a.actorId.slice(0, 8)}…</span> · {formatRelativeDate(a.createdAt)}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </AdminShell>
  );
}
